/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlumeOulinesGeometry
 */
export interface PlumeOulinesGeometry {
    /**
     * 
     * @type {PlumeOulinesGeometryTypeEnum}
     * @memberof PlumeOulinesGeometry
     */
    type?: PlumeOulinesGeometryTypeEnum;
    /**
     * 
     * @type {Array<Array<Array<Array<number>>>>}
     * @memberof PlumeOulinesGeometry
     */
    coordinates?: Array<Array<Array<Array<number>>>>;
}


/**
 * @export
 */
export const PlumeOulinesGeometryTypeEnum = {
    MultiPolygon: 'MultiPolygon'
} as const;
export type PlumeOulinesGeometryTypeEnum = typeof PlumeOulinesGeometryTypeEnum[keyof typeof PlumeOulinesGeometryTypeEnum];


/**
 * Check if a given object implements the PlumeOulinesGeometry interface.
 */
export function instanceOfPlumeOulinesGeometry(value: object): value is PlumeOulinesGeometry {
    return true;
}

export function PlumeOulinesGeometryFromJSON(json: any): PlumeOulinesGeometry {
    return PlumeOulinesGeometryFromJSONTyped(json, false);
}

export function PlumeOulinesGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlumeOulinesGeometry {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'coordinates': json['coordinates'] == null ? undefined : json['coordinates'],
    };
}

export function PlumeOulinesGeometryToJSON(json: any): PlumeOulinesGeometry {
    return PlumeOulinesGeometryToJSONTyped(json, false);
}

export function PlumeOulinesGeometryToJSONTyped(value?: PlumeOulinesGeometry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

